module.exports = __webpack_public_path__ + "static/resources-list-b0b45bbb5b43c652decba1939df3df81.png";